module.exports = __webpack_public_path__ + "img/alle-folders.831cf3b.png";